<template>
  <form class="a-filter admin-filter" action="">
    <div class="a-filter__header">
      <h2 v-t="'admin.contractors'"></h2>
    </div>
    <div class="a-filter__body ">
      <div class="a-filter__block admin-filter__block">
        <div class="a-filter__label admin-filter__label">{{$t('form.contractor-search.registration-date.label')}}:</div>
        <div class="a-input-group ">
          <p>{{$t('form.contractor-search.registration-date.from.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="startOfDay" v-model="filters.period.from"></date-picker>
        </div>
        <div class="a-input-group ">
          <p>{{$t('form.contractor-search.registration-date.to.label')}}:</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="endOfDay" v-model="filters.period.to"></date-picker>
        </div>
      </div>

      <div class="a-container-form ">
        <div class="a-label a-label--w-215" v-t="'form.contractor-search.organization.label'"></div>
        <organization-search class="select-w-570"
                             multiple
                             tags
                             :placeholder="$t('form.contractor-search.organization.placeholder')"
                             v-model="filters.organizations">
        </organization-search>
      </div>
      <div class="a-container-form">
        <div class="a-label a-label--w-215" v-t="'form.contractor-search.person-status.label'"></div>
        <dropdown-new class="select-w-260"
                      :placeholder="$t('form.contractor-search.person-status.placeholder')"
                      :options="[
                        { id: enums.PersonStatus.RESIDENT, name: $t('person-status.resident')},
                        { id: enums.PersonStatus.NON_RESIDENT, name: $t('person-status.non-resident')}
                      ]"
                      v-model="filters.personStatus">>
        </dropdown-new>
      </div>
    </div>
    <div class="a-filter__footer ">
      <button class="gui-btn gui-btn--white-border gui-btn--w-167" type="button" @click="resetFilters" v-t="'buttons.reset-filters'"></button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="fetchContractors" v-t="'buttons.apply'"></button>
    </div>
    <loading v-if="loading"/>
  </form>
</template>

<script>
  import OrganizationSearch from '@/components/common/inputs/OrganizationSearch'

  export default {
    components: {
      OrganizationSearch
    },

    data: () => ({
      loading: false,

      filters: {
        period: {
          from: undefined,
          to: undefined
        },
        organizations: [],
        personStatus: undefined
      }
    }),

    methods: {
      async fetchContractors() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('fetchContractors', {
              from: this.filters.period.from,
              to: this.filters.period.to,
              organizations: (this.filters.organizations || []).map(e => e.id),
              personStatus: this.filters.personStatus ? this.filters.personStatus.valueOf() : undefined
            });
          }
          catch(e) {
            console.error('unable to fetch list of contractors', e);

            this.showError({
              error: 'errors.unknown'
            });
          }
        });
      },

      resetFilters() {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    }
  }
</script>

<style scoped>

</style>
